import cn from '@/lib/clsxm';

import Container from '@/components/@base/container';
import { CONTAINER_TAG_TYPE } from '@/components/@base/container/type';
import List from '@/components/@base/list';
import HighlightItem from '@/components/app/product/components/@shared/highlight-item';
import Props from '@/components/app/product/components/highlights/type';
import PromoteVideoBtn from '@/components/app/product/components/promote-video/promote-video-btn';

import { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;

export default function Highlights({
  highlights,
  className,
  listItemClassName,
  noHeader = false,
  promoteVideo,
  promoteVideoCover,
}: Props) {
  const shouldLimitHighlights = promoteVideo;
  const displayedHighlights = shouldLimitHighlights ? highlights?.slice(0, 4) : highlights;
  return (
    <>
      <Container
        type={CONTAINER_TAG_TYPE.SECTION}
        className={cn(
          'bg-[linear-gradient(180deg,_#F9FAFC_0%,_#FFFFFF_30.97%) border-b-[1px] border-b-[#F4F5F6] md:border-dashed md:border-b-[#0000001A]',
          className,
        )}
      >
        {shouldLimitHighlights && (
          <PromoteVideoBtn promoteVideo={promoteVideo} promoteVideoCover={promoteVideoCover} />
        )}
        {!noHeader && (
          <Container
            type={CONTAINER_TAG_TYPE.HEADER}
            className='text-lg font-bold whitespace-nowrap text-[#424B57]'
          >
            {productLocalization.highlights}
          </Container>
        )}
        <List className='py-2'>
          {displayedHighlights?.map((item, index) => (
            <HighlightItem key={index} text={item} className={listItemClassName} />
          ))}
        </List>
      </Container>
    </>
  );
}
